<template>
       <div class="has-text-centered has-text-white scrollableY">
            <div class="container">
                <div class="bottom20">&nbsp;</div>
                <H1 class="is-size-3 has-text-white" @click="test"><img src="@/assets/img/fourDotsLogo.png" width="24"/> REGISTER</H1>
                <div class="top10">&nbsp;</div>
                <div class="limitWidth  marginAutod has-text-centered">
                    <input type="text" id="dummyText" style="position: absolute; top: -2000px" />
                    
                   
    
                    <form class="form has-text-left" v-on:submit.prevent="submitForm" v-if="showForm">
                        <div class="field" :class="{formError: errors.first('fName') }">
                            First Name:
                            <input type="text" class="input is-coolGreen" name="fName"  v-validate="'required'" v-model="form.fName" />
                            <p class="help is-danger" >
                                {{ errors.first('fName') }}
                            </p>
                        </div>
                        <div class="field" :class="{formError: errors.first('lName') }">
                            Last Name:
                            <input type="text" class="input is-coolGreen" name="lName" v-validate="'required'" v-model="form.lName"/>
                            <p class="help is-danger" >
                                {{ errors.first('lName') }}
                            </p>
                        </div>
                       <!--  <div class="field">
                            Company:
                            <input type="text" class="input is-coolGreen" name="Company" v-model="form.company"/>
                        </div> -->
                      <!--   <div class="field" :class="{formError: errors.first('phone') }">
                            Phone Number:*
                            <input type="text" class="input is-coolGreen" name="phone" v-validate="'required'" v-model="form.phone"/>
                            <p class="help is-danger" >
                                {{ errors.first('phone') }}
                            </p>
                        </div> -->
                        <div class="field top40" :class="{formError: errors.first('Email') }">
                            Email:
                            <input type="text" class="input is-coolGreen" name="Email" v-validate="'required|email'" v-model="form.email" />
                            <p class="help is-danger" >
                                {{ errors.first('Email') }}
                            </p>
                        </div>
                       <!--  <div class="field" :class="{formError: errors.first('email2') }">
                            Confirm Email:*
                            <input type="text" class="input is-coolGreen" name="email2" v-validate="{required:true, is: form.email}"  />
                            <p class="help is-danger" >
                                {{ errors.first('email2') }}
                            </p>
                        </div> -->
                      <!--   <div class="field" :class="{formError: errors.first('Address') }">
                            Address:*
                            <input type="text" class="input is-coolGreen" name="Address" v-validate="{required:true}" v-model="form.shipAddress1"  />
                            <p class="help is-danger" >
                                {{ errors.first('Address') }}
                            </p>
                        </div>
                        <div class="field" :class="{formError: errors.first('Address2') }">
                            <input type="text" class="input is-coolGreen" name="Address2"  v-model="form.shipAddress2" />
                            <p class="help is-danger" >
                                {{ errors.first('Address2') }}
                            </p>
                        </div>
                        <div class="field" :class="{formError: errors.first('City') }">
                            City:*
                            <input type="text" class="input is-coolGreen" name="City" v-validate="'required'" v-model="form.shipCity"/>
                            <p class="help is-danger" >
                                {{ errors.first('City') }}
                            </p>
                        </div>
                        <div class="field" :class="{formError: errors.first('State') }">
                            State:
                            <input type="text" class="input is-coolGreen" name="State" v-validate="'required'" v-model="form.shipState" />
                            <p class="help is-danger" >
                                {{ errors.first('State') }}
                            </p>
                        </div>
                        <div class="field" :class="{formError: errors.first('Zip') }">
                            Zip:*
                            <input type="text" class="input is-coolGreen" name="Zip" v-validate="'required'" v-model="form.shipZip"/>
                            <p class="help is-danger" >
                                {{ errors.first('Zip') }}
                            </p>
                        </div> -->
                      <!--   <div class="field" :class="{formError: errors.first('Country') }">
                            Country:*<br/>
                            <div class="select is-coolGreen ">
                                <select name="Country" v-validate="'required'" v-model="form.shipCountry"  style="width: 500px">
                                    <option disabled value="">Select...</option>
                                    <option v-for="item in countries" :key="item.code" v-bind:value="item.code">{{item.name}}</option>
                                </select>
                            </div>
                            <p class="help is-danger" >
                                {{ errors.first('Country') }}
                            </p>
                        </div> -->
                        
                        <div class="field top40 posRelative" :class="{formError: errors.first('Password') }" >
                            Password:
                            <input class="input is-coolGreen" :type="pType" name="Password" v-validate="{required: true, min:8, regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/}" v-model="form.password"/>
                            <div class="eye"><i class="fa fa-eye" @click="togglePtype"></i></div>
                            <p class="help is-danger" >
                                {{ errors.first('Password') }}
                            </p>
                            <div class="is-size-8 has-text-weight-light">(At least 8 characters long, at least one number, at least one lowercase letter, at least one uppercase letter and at least one special character)</div>
                           
                        </div>
                      <!--   <div class="field" :class="{formError: errors.first('password2') }">
                            Confirm Password:*
                            <input class="input is-coolGreen" type="password" name="password2" v-validate="{required:true, is: form.password}" />
                            <p class="help is-danger" >
                                {{ errors.first('password2') }}
                            </p>
                            <div class="is-size-8 has-text-weight-light">(At least 8 characters long, at least one number, at least one lowercase letter, at least one uppercase letter and at least one special character)</div>
                        </div> -->
    
                        <div class="field top40" :class="{formError: errors.first('Profile') }">
                            Profile Handle:
                            <input type="text" class="input is-coolGreen" name="Profile" v-validate="'required'" v-model="form.profile"/>
                            <span class="is-size-8 has-text-weight-light">This is how you will be identified if you post anything publicly.</span>
                            <p class="help is-danger" >
                                {{ errors.first('Profile') }}
                            </p>
                            <p v-show="handleTaken" class="help is-danger is-size-5" >
                                {{handleErr}}
                            </p>
                        </div>
    
                       <!--   <div class="field">
                            Driver's License Image:*
                            <input type="file"
                                id="dl" name="dl"
                                accept="image/png, image/jpeg" />
                        </div> -->
                        <div class="field" :class="{formError: errors.first('terms') }">
                            <label class="checkbox">
                                <input type="checkbox" name="terms" v-validate="'required'" v-model="form.terms">
                                <a href="/terms" target="_blank">&nbsp;&nbsp; I agree to the <b>terms and conditions</b></a>
                                <p class="help is-danger" >
                                    {{ errors.first('terms') }}
                                </p>
                            </label>
                        </div>
    
                       
                        <div class="field">
                            <div id="recaptcha"></div>
                            <p class="help is-danger" >
                                {{ recaptchaError }}
                            </p>
                        </div>

                        <div class="field">
                            <button id="submitRegistration" class="button is-coolGreen top10">SUBMIT</button>
                        </div>
                        <div class="has-text-danger has-text-weight-bold" v-show="showErrorsLine == true">Please correct the errors in the form and submit again.</div>
                    </form>
    
                    <form class="form has-text-left" v-on:submit.prevent="submitConfirmForm" v-if="showConfirm">
                        <h2>Please enter the confirmation code we sent to <b>{{this.form.email}}</b> to confirm your email address.</h2>
                        <div class="field top40" :class="{formError: errors.first('confirmationCode') }">
                            Code:
                            <input type="text" class="input is-coolGreen" name="confirmationCode" v-validate="'required'" v-model="confirmForm.confirmationCode" key="confirmForm.confirmationCode"/>
                            <p class="help is-danger" >
                                {{ errors.first('confirmationCode') }}
                            </p>
                        </div>
                        <div class="field top20">
                            <button id="submitConfirm" class="button is-coolGreen top10">SUBMIT</button>&nbsp;
                            <button id="resendCode" title="Button may be clicked only once every 30 seconds." class="button is-coolGreen top10" @click.prevent="onResendCode" :disabled="codeResent">RESEND CODE</button>
                        </div>
                        <div class="has-text-danger has-text-weight-bold" v-show="showErrorsLine == true">Please correct the errors in the form and submit again.</div>
                        <div class="has-text-danger has-text-weight-bold top10" v-show="confirmError">{{ confirmError }}</div>
                    </form>
    
                    <form class="form has-text-left" v-on:submit.prevent="submitPlanForm" v-show="showPlans">
                        <h2>Please confirm your plan choice:</h2>
                        <div class="top40">
                            <div class="field" v-for="p in plans" :key="p.code">
                                <input
                                class="is-coolGreen"
                                :id="p.code"
                                type="radio"
                                name="plan"
                                :value="p.code"
                                v-model="plan"
                                @change="onPlanChange"
                                />
                                <label for="p.code"> {{ p.name }}{{ p.code === 'free' ? '' : ' - $' + p.price + '/' + p.units }}{{ p.recommended ? ' (Best Value)' : ''}}</label>
                            </div>
                        </div>
                        <div v-show="showPlans && showCardFields()">
                            <div v-if="showPlans && showCardFields()">
                                <div class="top40">
                                    <h2>Please enter your billing address:</h2>
                                </div>
    
                                <div class="field top40" :class="{formError: errors.first('address1')}">
                                    Address:
                                    <input type="text" class="input is-coolGreen" name="address1" v-validate="'required'" v-model="planForm.address1" />
                                    <p class="help is-danger" >
                                        {{ errors.first('address1') }}
                                    </p>
                                </div>
    
                                <div class="field">
                                    <br />
                                    <input type="text" class="input is-coolGreen" name="address2" v-model="planForm.address2" />
                                </div>
    
                                <div class="field" :class="{formError: errors.first('city')}">
                                    City:
                                    <input type="text" class="input is-coolGreen" name="city" v-validate="'required'" v-model="planForm.city" />
                                    <p class="help is-danger" >
                                        {{ errors.first('city') }}
                                    </p>
                                </div>
    
                                <div class="field" :class="{formError: errors.first('state')}">
                                    State:
                                    <input type="text" class="input is-coolGreen" name="state" v-validate="'required'" v-model="planForm.state" />
                                    <p class="help is-danger" >
                                        {{ errors.first('state') }}
                                    </p>
                                </div>
    
                                <div class="field" :class="{formError: errors.first('zip')}">
                                    Zip:
                                    <input type="text" class="input is-coolGreen" name="zip" v-validate="'required'" v-model="planForm.zip" />
                                    <p class="help is-danger" >
                                        {{ errors.first('zip') }}
                                    </p>
                                </div>
    
                                <div class="field" :class="{formError: errors.first('country') }">
                                    Country:<br/>
                                    <div class="select is-coolGreen width100">
                                        <select name="country" class="width100 billing-dropdown"  v-validate="'required'" v-model="planForm.country">
                                            <option disabled value="">Select...</option>
                                            <option v-for="item in countries" :key="item.code" v-bind:value="item.code">{{item.name}}</option>
                                        </select>
                                    </div>
                                    <p class="help is-danger" >
                                        {{ errors.first('country')}}
                                    </p>
                                </div>

                                <div class="top40">
                                    <h2>Please enter your card info:</h2>
                                    <h4 v-if="$root.app.DEBUG">
                                        4242424242424242 (accepted)<br />
                                        4000002500003155 (3d Secure)<br />
                                        4000000000000002 (declined)
                                    </h4>
                                </div>
    
                                <div class="field top40">
                                    Name on Card:
                                    <input type="text" class="input is-coolGreen" v-model="planForm.nameOnCard" />
                                </div>
                                <div></div>
    
                            </div>
                            <div class="field">
                                Card Number:
                                <div class="stripe-field">
                                    <div id="card-number-element"></div>
                                </div>
                            </div>
                            <div class="field">
                                Card Expiration:
                                <div class="stripe-field">
                                    <div id="card-expiry-element"></div>
                                </div>
                            </div>
                            <div class="field">
                                Card CVC:
                                <div class="stripe-field">
                                    <div id="card-cvc-element"></div>
                                </div>
                            </div>
                        </div>
                        <div class="field top40">
                            <button id="submitPlan" class="button is-coolGreen top10">SUBMIT</button>
                        </div>
                        <div class="has-text-danger has-text-weight-bold" v-show="showErrorsLine == true">Please correct the errors in the form and submit again.</div>
                        <div class="has-text-danger has-text-weight-bold top10" v-show="stripeError">{{ stripeError }}</div>
                    </form>
    
                    <div v-if="showThankYou">
                        <div class="subtitle has-text-white">
                            Thank you for registering!
                        </div>
                        <div>
                            Please login by clicking below.
                        </div>
    
                        <div class="top20 bottom40">
                            <button class="button is-coolGreen" @click="login">LOG IN</button>
                        </div>
                    </div>
                </div>
       </div>
       <footerdiv class="top160"></footerdiv>
        </div>
</template>

<script>

import countries from '../static/countries.js'
import Footerdiv from '../components/Footer.vue'
var AmazonCognitoIdentity = require('amazon-cognito-identity-js')
let loadStripe;

export default {
  components: {
      Footerdiv
  },
  data: function () {
    var self = this
    var form = {
      fName: '',
      lName: '',
      email: '',
      shipAddress1: '',
      shipAddress2: '',
      shipCity: '',
      shipState: '',
      shipZip: '',
      shipCountry: '',
      password: '',
      phone: '',
      terms: false
     
      //profile: ''
    }
    var confirmForm = {
        confirmationCode: ''
    }
    var planForm = {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        nameOnCard: ''
    }

    return {
      form: form,
      confirmForm: confirmForm,
      planForm: planForm,
      showPoll: false,
      showForm: true,
      userSub: null,
      showConfirm: false,
      showPlans: false,
      showThankYou: false,
      countries: countries,
      showErrorsLine: false,
      handleTaken: false,
      handleErr: '',
      pType: 'password',

      recaptchaResponse: true,
      recaptchaPassed: false,

      codeResent: false,
      recovered: false,

      recaptchaError: '',
      confirmError: null,

      plans: null,
      plan: null,
      stripe: null,
      stripeError: null,

    }
  },
  mounted: async function(){
    let self = this;

    //this.$root.app.autoSelectPlan =  null

    // Setup reCaptcha.
    // There is a race condition between loading the reCaptcha library
    // and rendering the reCaptcha so the following code attempt to render
    // up to 10 times.  Note, don't do reCaptcha if mobile app.
    if (!this.$root.app.inApp) {
        setTimeout(function setupReCaptcha(count) {
            let done = false;
            if (grecaptcha && grecaptcha.ready) {
                try {
                    grecaptcha.render('recaptcha', {
                        'sitekey': process.env.VUE_APP_RE_CAPTCHA_PUB_KEY,
                        'callback': () => {self.recaptchaError = ''}
                    });
                    done = true;
                } catch(e) {
                }
            }
            if (!done && count < 10) {
                setTimeout(setupReCaptcha, 100, count + 1);
            }
        }, 100, 0);
    }

    // Load plans.
    self.$root.app.apiClient.get('open/confirm/plans', {}, (plans) => {
        self.plans = plans;
    }, (e) => {
        console.log(e);
    });

    let stripeStyle = {
        base: {
            color: '#fff',
            fontSize: '16px',
            '::placeholder': {
                color: '#888'
            },
            backgroundColor: '#333'
        }
    }

    // Initialize Stripe
    if(!this.$root.app.inApp){

        if (!loadStripe) {
            loadStripe = (await import('@stripe/stripe-js')).loadStripe;
        }
        
        this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUB_KEY);
        this.elements = this.stripe.elements();

        this.cardNumberElement = this.elements.create('cardNumber', {
            style: stripeStyle
        });
        this.cardNumberElement.mount('#card-number-element');

        this.cardExpiryElement = this.elements.create('cardExpiry', {
            style: stripeStyle
        });
        this.cardExpiryElement.mount('#card-expiry-element');

        this.cardCvcElement = this.elements.create('cardCvc', {
            style: stripeStyle
        });
        this.cardCvcElement.mount('#card-cvc-element');
    }

  },
  methods: {
    test: function(){
        this.$root.app.showModalLogin({})
    },
    togglePtype: function(){
        if(this.pType == 'password')
            this.pType = 'text'
        else
            this.pType = 'password'
    },
    submitForm: function () {
      var self = this

  

      //this.form.dl = document.getElementById('dl').Value();

      // Don't do reCaptcha if mobile app. 
      if (!this.$root.app.inApp) {
        self.recaptchaResponse = grecaptcha.getResponse();
        if (!self.recaptchaResponse) {
            this.recaptchaError = 'The reCaptcha is required';
        }
      }

      this.$validator.validateAll().then(res => {
        if (res && self.recaptchaResponse) {
          self.showErrorsLine = false;
          //console.log(self.form)  

          // Don't do reCaptcha if mobile app. 
          if (!this.$root.app.inApp) {
            az.addRemSpinner(true, 'id', 'submitRegistration');
            self.$root.app.apiClient.post('open/confirm/recaptcha', {token: self.recaptchaResponse}, (response) => {
                if (response.result === 'success' || self.recaptchaPassed) {
                    self.recaptchaPassed = true;
                    doRegistration();
                } else {
                    az.addRemSpinner(false, 'id', 'submitRegistration');
                    this.recaptchaError = 'ReCaptcha test failed.  Please try again.';
                }
            }, (e) => {
                az.addRemSpinner(false, 'id', 'submitRegistration');
                console.log(e);
            });
          } else {
            az.addRemSpinner(true, 'id', 'submitRegistration');
            doRegistration();
          }

        } else {
          //this.$root.showModalOK({message: 'Please correct the errors on the form'})
          self.showErrorsLine = true;
        }
      })

      function doRegistration () {
        //document.getElementById('dummyText').focus()

        console.log('call reg')

        //check handle uniqueness
        function w(d){
            if(d == 'ok'){
                console.log('call cog')
                self.form.email = self.form.email.toLowerCase()
                
                var bundle = JSON.parse(JSON.stringify(self.form));
                delete bundle.password
                bundle.regCart = JSON.stringify(self.$root.app.cartContents);
                //TODO this should not be set here, but rather 
                if(az.getCookieValue('ref') != undefined && az.getCookieValue('ref') != false){
                    bundle.referedBy = az.getCookieValue('ref');
                }

                var attributes = [
                    {Name: 'given_name', Value: self.form.fName},
                    {Name: 'family_name', Value: self.form.lName},
                    //{Name: 'fromReg', Value: true},
                    {Name: 'custom:bundle', Value: JSON.stringify(bundle)},

                    //TODO this should not be set here! rather when checkout succeeds, here for now until checkout in place.
                    {Name: 'custom:subsStatus', Value: 'active'}
                ]

                self.$root.app.azCognito.signUp(self.form.email.toLowerCase(), self.form.password, attributes, signUpCallback)
             } else if(d == 'handle taken'){
                // Check here if there is an unconfirmed user with current email address.
                let body = {
                    firstName: self.form.fName,
                    lastName: self.form.lName,
                    email: self.form.email.toLowerCase(),
                    handle: self.form.profile,
                    clientId: process.env.VUE_APP_COG_CLIENT_ID,
                }
                self.$root.app.apiClient.post('open/confirm/recover', body, response => {
                    if (response.recovered) {
                        self.recovered = true;
                        self.userSub = response.sub;
                        self.showForm = false;
                        self.showConfirm = true;
                        document.getElementById('dummyText').focus()
                    } else {
                        az.addRemSpinner(false, 'id', 'submitRegistration');
                        self.handleErr = 'This handle is already taken. Please choose a different one.'
                        self.handleTaken = true
                        self.preventSubmit = false
                    }
                }, e => {})
            }
            //az.addRemSpinner(false, 'id', 'submitRegistration');
        } 

        function n(){
            az.addRemSpinner(true, 'id', 'submitRegistration');
        }

        self.handleTaken = false
        if(self.form.profile.split(" ").length > 1){
            self.handleErr = 'Profile handle cannot contain spaces'
            self.handleTaken = true
            az.addRemSpinner(false, 'id', 'submitRegistration');
            return
        }
       
        self.$root.app.apiClient.get('open/confirm/checkhandle/' + self.form.profile.toLowerCase(), {}, w, n)
        
        function signUpCallback (result, obj) {

            az.addRemSpinner(false, 'id' , 'submitRegistration');
            if (result == 'error') {
                if (obj.code == 'UsernameExistsException') {
                    let body = {
                        firstName: self.form.fName,
                        lastName: self.form.lName,
                        email: self.form.email.toLowerCase(),
                        handle: self.form.profile,
                        clientId: process.env.VUE_APP_COG_CLIENT_ID,
                    }
                    self.$root.app.apiClient.post('open/confirm/recover', body, response => {
                        if (response.recovered) {
                            self.recovered = true;
                            self.userSub = response.sub;
                            self.showForm = false;
                            self.showConfirm = true;
                            document.getElementById('dummyText').focus()
                        } else {
                            az.addRemSpinner(false, 'id', 'submitRegistration');
                            self.$root.app.showModalOK({message: 'The email you provided is already in use, please provide a different one.'})
                        }
                    }, e => {})
                    
                   
                } else {
                    self.$root.app.showModalOK({message: 'There was an error processing your request. Please try again later or contact support.'})
                  
                    
                }
                return
            }
            document.cookie = "ref=false"
            self.userSub = obj.userSub;
            self.showForm = false;
            self.showConfirm = true;
            document.getElementById('dummyText').focus()
        }
      }
    },
    submitConfirmForm: function() {
      var self = this
      this.$validator.validateAll().then(res => {
        if (res) {
          self.showErrorsLine = false;
          self.confirmError = null;
          az.addRemSpinner(true, 'id', 'submitConfirm');
          let body = {
              code: this.confirmForm.confirmationCode,
              username: this.userSub,
              clientId: process.env.VUE_APP_COG_CLIENT_ID
          }
          if (self.recovered) {
              body.password = this.form.password;
          }
          self.$root.app.apiClient.put('open/confirm', body,
          // Success
          () => {
              az.addRemSpinner(false, 'id', 'submitConfirm');
              self.showConfirm = false;


              if(self.$root.app.inApp || self.$root.app.autoSelectPlan == 'free'){
                self.plan = 'free'
                self.submitPlanForm()
              } else {
                self.plan = self.$root.app.autoSelectPlan
                self.showPlans = true;
                self.planForm.nameOnCard = self.form.fName + ' ' + self.form.lName;
              }

          },
          // Error
          (e) => {
              // Note: apiClient doesn't currently pass any error info so just assume
              // they gave the wrong code.
              // TODO - Check the error if/when apiClient is fixed.
              az.addRemSpinner(false, 'id', 'submitConfirm');
              self.confirmError = "Incorrect conformation code"
          })
        } else {
          self.showErrorsLine = true;
        }
      })
    },
    submitPlanForm: function() {
      var self = this
      this.$validator.validateAll().then(async success => {
        if (success) {
          self.showErrorsLine = false;
          az.addRemSpinner(true, 'id', 'submitPlan');
          let price = this.getPlanPrice();

          if (price > 0) {
            
            self.$root.app.apiClient.post('open/subscribe', {
              sub: this.userSub,
              planCode: this.plan
            }, (res) => {

              // Success
              let secret = res.secret;
              this.stripe.confirmCardPayment(res.secret, {
                payment_method: {
                  card: this.cardNumberElement,
                  billing_details: {
                    name: this.planForm.nameOnCard,
                    address: {
                      line1: this.planForm.address1,
                      line2: this.planForm.address2,
                      city: this.planForm.city,
                      state: this.planForm.state,
                      postal_code: this.planForm.zip,
                      country: this.planForm.country,
                    },
                  }
                }
              }).then(async result => {
                az.addRemSpinner(false, 'id', 'submitPlan');
                
                if (result.error) {
                  this.stripeError = result.error.message;
                } else {
                  document.getElementById('routerView').scrollTo(0, 0);
                  self.showPlans = false;
                  self.showThankYou = true;
                  self.$root.app.autoSelectPlan = null
                }
              });
            }, (e) => {

              // Failure
              console.log(e);

            });

          } else {
            // Make it look like it did something.
            setTimeout(() => {
              az.addRemSpinner(false, 'id', 'submitPlan');
              self.showPlans = false;
              self.showThankYou = true;
            }, 1000);
          }

        } else {
          self.showErrorsLine = true;
          self.stripeError = null;
        }
      })
    },
    onResendCode() {
        // Code may only be re-sent once every 30 seconds.
        if (!this.codeResent) {
            az.addRemSpinner(true, 'id', 'resendCode');
            this.codeResent = true;
            // Set timer to renable button.
            setTimeout(() => {
                this.codeResent = false;
            }, 30000);
            console.log('sent')
            this.$root.app.azCognito.resendConfirmationCode(this.userSub, () => {
                az.addRemSpinner(false, 'id', 'resendCode');
            });
        }
    },
    login: function () {
      this.$root.app.showModalLogin({})
      this.$router.push('/')
    },
    pollDone: function(results){
        this.form.pollResults = results;
        this.showPoll = false;
        this.showForm = true;
    },
    onPlanChange() {
        //this.submitDisabled = false;
    },
    getPlanPrice() {
        let price = null;
        for (let p of this.plans) {
            if (p.code == this.plan) {
                price = p.price;
                break;
            }
        }

        return parseFloat(price);
    },
    showCardFields() {
        if (this.plans) {
            return this.getPlanPrice() > 0;
        } else {
            return false;
        }
    },
  }
}
</script>

<style scoped>

 a {
    color: white;
 }

 a:hover {
    color: #aaa
 }

 input{
    background-color: #333;
    border: none;
    border-bottom: 1px solid #f1c232;
    color: white
 }

</style>
